// extracted by mini-css-extract-plugin
module.exports = {"amount":"StakedCard_amount__-L5hl","small":"StakedCard_small__h-F6c","value":"StakedCard_value__2JpZ8","card":"StakedCard_card__2BapI"};